import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export async function getElasticConfig(userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.get("api/elasticConfig", { params: { userKey } });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export default async function getESRanges(requestData, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.post("api/getESRanges", { ...requestData, userKey });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
